const o = "style-module__footer___0X-Tm", e = "style-module__widthWrapper___4IFks", t = "style-module__gridContainer___hbHNu", _ = "style-module__logoContainer___ME2YB", n = "style-module__large___ue7OS", l = "style-module__headerLanguageSelector___PgcW9", a = "style-module__logo___Bqf3G", s = "style-module__logoImage___r-v21", r = "style-module__column___eVfbq", c = "style-module__headerLabel___qPLp3", i = "style-module__menuItem___Zpwqm", m = "style-module__menuIcon___F95YB", u = "style-module__askQuestion___Qat6y", g = "style-module__requestLawyer___-kkLF", d = "style-module__socialContainer___A132u", y = "style-module__socialIconContainer___8VDXl", C = "style-module__socialIcon___VaL9I", I = "style-module__bottomBarContainer___Jg-GO", p = "style-module__bottomSocialContainer___RlVvq", h = "style-module__languageSelectorContainer___WIIDy", L = "style-module__copyright___H-at0", b = "style-module__copyrightBottom___DJjET", S = "style-module__sitemapLink___AgYrR", k = {
  footer: o,
  widthWrapper: e,
  gridContainer: t,
  logoContainer: _,
  large: n,
  headerLanguageSelector: l,
  logo: a,
  logoImage: s,
  column: r,
  headerLabel: c,
  menuItem: i,
  menuIcon: m,
  askQuestion: u,
  requestLawyer: g,
  socialContainer: d,
  socialIconContainer: y,
  socialIcon: C,
  bottomBarContainer: I,
  bottomSocialContainer: p,
  languageSelectorContainer: h,
  copyright: L,
  copyrightBottom: b,
  sitemapLink: S
};
export {
  u as askQuestion,
  I as bottomBarContainer,
  p as bottomSocialContainer,
  r as column,
  L as copyright,
  b as copyrightBottom,
  k as default,
  o as footer,
  t as gridContainer,
  c as headerLabel,
  l as headerLanguageSelector,
  h as languageSelectorContainer,
  n as large,
  a as logo,
  _ as logoContainer,
  s as logoImage,
  m as menuIcon,
  i as menuItem,
  g as requestLawyer,
  S as sitemapLink,
  d as socialContainer,
  C as socialIcon,
  y as socialIconContainer,
  e as widthWrapper
};
